import EmailLayout from './email-layout';
export default EmailLayout;
